import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import toast from "react-hot-toast";
import ajaxStationSales from "../../util/remote/ajaxStationSales";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export default function AttendantSalesLitersBarChart() {
  const station_id = Number(window.localStorage.getItem("FuelFy@station_id"));

  const getCurrentMonth = () => {
    const d = new Date();
    return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}`;
  };

  const [month, setMonth] = useState(getCurrentMonth());
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  const fetchSales = async () => {
    const response = await ajaxStationSales.monthly_attendant_sales({
      station_id,
      month,
    });

    if (response.status === "OK") {
      const details = Array.isArray(response.details) ? response.details : [];
      const labels = details.map(
        (item) => `${item.first_name} ${item.last_name}`
      );
      const totals = details.map((item) => Number(item.total_litres));

      setChartData({
        labels,
        datasets: [
          {
            label: "Total Liters Served",
            data: totals,
            backgroundColor: "#1E88E5",
            borderRadius: 6,
          },
        ],
      });
    } else {
      toast.error(response.message);
    }
  };

  useEffect(() => {
    if (station_id) fetchSales();
  }, [month]);

  return (
    <div className="container-fluid">
      <h2 className="mb-3">Total Liters Per Attendant</h2>

      {/* Month Selector */}
      <div className="mb-4">
        <label className="fw-medium me-2">Select Month:</label>
        <input
          type="month"
          value={`${month.slice(0, 4)}-${month.slice(4, 6)}`}
          onChange={(e) => {
            const [yr, mn] = e.target.value.split("-");
            setMonth(`${yr}${mn}`);
          }}
          className="form-control d-inline-block"
          style={{ width: "200px" }}
        />
      </div>

      {/* Responsive Chart Container */}
      <div
        className="w-100"
        style={{
          height: "380px", // Bootstrap-friendly fixed height
        }}
      >
        <Bar
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false, // Required for responsive height
            plugins: {
              legend: { display: false },
              datalabels: {
                anchor: "end",
                align: "top",
                color: "#000",
                font: { weight: "bold" },
                formatter: (value) => value.toLocaleString(),
              },
            },
            scales: {
              y: {
                beginAtZero: true,
                title: { display: true, text: "Liters" },
              },
              x: {
                title: { display: true, text: "Attendants" },
              },
            },
          }}
        />
      </div>
    </div>
  );
}
